import React, { useEffect, useState } from "react";
import { Row, Col, Button, Card, message, Skeleton } from "antd";
import Layout from "../../../layout/Dashboard";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";
import Icon from "@ant-design/icons";
import "./list.css";
import { eyeIcon, trashIcon, penIcon } from "../../../util/icons";
import firebase from "../../../config/FirebaseConfig";

export default function List() {
  const history = useHistory();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = firebase.firestore().collection("/articles");

  useEffect(() => {
    const getArticles = async () => {
      ref
        .get()
        .then((snapshot) => {
          const temp = [];
          snapshot.forEach((doc) => {
            temp.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          setArticles(temp);
          setLoading(false);
        })
        .catch((err) => {
          console.log("Error getting documents", err);
        });
    };
    getArticles();
  });

  function formatDate(date) {
    const bulan = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Nov",
      "Okt",
      "Des",
    ];
    return (
      date.getDate() + " " + bulan[date.getMonth()] + " " + date.getFullYear()
    );
  }

  return (
    <div id="article_list">
      <Layout>
        <Row justify="space-between" align="middle" id="row1">
          <Col>
            <div className="header">Artikel</div>
          </Col>
          <Col>
            <Link to="/dashboard/article-add">
              <Button icon={<PlusOutlined />} className="button_secondary">
                Tulis Artikel
              </Button>
            </Link>
          </Col>
        </Row>
        <Row>
          <Skeleton loading={loading}>
            {articles.map((article) => (
              <Col span={23} key={article.title}>
                <Card className="article_item">
                  <Row justify="space-between" align="middle">
                    <Col>
                      <div className="title">{article.title}</div>
                      <div className="desc">
                        Dipublikasikan: {formatDate(article.createdAt.toDate())}
                      </div>
                    </Col>
                    <Col span={3}>
                      <Row justify="space-around">
                        <Col>
                          <Icon
                            component={penIcon}
                            onClick={() => {
                              history.push(
                                `/dashboard/article-edit/${article.id}`
                              );
                            }}
                          />
                        </Col>
                        <Col>
                          <Icon
                            component={eyeIcon}
                            onClick={() => {
                              history.push(`/dashboard/article/${article.id}`);
                            }}
                          />
                        </Col>
                        <Col>
                          <Icon
                            component={trashIcon}
                            onClick={async () => {
                              ref
                                .doc(`${article.id}`)
                                .delete()
                                .then(() => {
                                  message.success("Artikel berhasil dihapus");
                                })
                                .catch((err) => {
                                  console.log(err);
                                  message.error("Artikel gagal dihapus");
                                });
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Skeleton>
        </Row>
      </Layout>
    </div>
  );
}
